import noCdmIcon from "assets/images/cdm/empty-cdm.svg";

import style from "./NoCdmSection.module.css";

export const LoadingSection = () => {
  return (
    <section className={style.emptyState}>
      <img className={style.element} alt="Element" src={noCdmIcon} />
      <div className={style.text}>
        <div className={style.div}>
          <div className={style.textWrapper}>Loading...</div>
          <p className={style.onceThePatient}>
            We are loading the data for this review.
          </p>
        </div>
      </div>
    </section>
  );
};
